import React from 'react';
import { faqs } from '../data/mockData';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

const FAQSection = () => {
  const half = Math.ceil(faqs.length / 2);
  const leftFaqs = faqs.slice(0, half);
  const rightFaqs = faqs.slice(half);

  return (
    <section id="faq" className="py-24 bg-cream-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-wine-500 mb-3">FAQ</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-wine-950 mb-4">Frequently Asked Questions</h2>
          <p className="text-stone-500">Common questions about trademark registration, copyright filing, and brand protection.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-6xl mx-auto" data-testid="faq-accordion">
          <Accordion type="single" collapsible className="space-y-3">
            {leftFaqs.map((faq) => (
              <AccordionItem key={faq.id} value={`item-${faq.id}`}
                className="bg-white rounded-xl px-6 border border-stone-200 hover:border-wine-400/50 transition-colors data-[state=open]:border-gold-400 data-[state=open]:shadow-md">
                <AccordionTrigger className="text-left text-sm font-medium text-wine-950 hover:text-wine-600 py-5 [&[data-state=open]]:text-wine-600">{faq.question}</AccordionTrigger>
                <AccordionContent className="text-stone-500 text-sm leading-relaxed pb-5">{faq.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          <Accordion type="single" collapsible className="space-y-3">
            {rightFaqs.map((faq) => (
              <AccordionItem key={faq.id} value={`item-${faq.id}`}
                className="bg-white rounded-xl px-6 border border-stone-200 hover:border-wine-400/50 transition-colors data-[state=open]:border-gold-400 data-[state=open]:shadow-md">
                <AccordionTrigger className="text-left text-sm font-medium text-wine-950 hover:text-wine-600 py-5 [&[data-state=open]]:text-wine-600">{faq.question}</AccordionTrigger>
                <AccordionContent className="text-stone-500 text-sm leading-relaxed pb-5">{faq.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
